import { Dashboard } from "./types";

const defaultState = {
    summary: {
        total_transactions: 0,
        volumes: [],
        from_date: "",
        to_date: "",
    },
    marketBreakdown: [],
    loading: false,
    error: null,
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case Dashboard.SET_SUMMARY:
            return { ...state, summary: { ...defaultState.summary, ...action.summary }, error: null };

        case Dashboard.SET_MARKET_BREAKDOWN:
            return { ...state, marketBreakdown: action.marketBreakdown, error: null };

        case Dashboard.SET_LOADING:
            return { ...state, loading: action.loading };

        case Dashboard.SET_ERROR:
            return { ...state, error: action.error, loading: false };

        default:
            return state;
    }
};
